export default __webpack_public_path__ + "static/media/note.a4bb2b6c.png";